import { render, staticRenderFns } from "./RelationalGraph.vue?vue&type=template&id=74dfe376&scoped=true"
import script from "./RelationalGraph.vue?vue&type=script&lang=js"
export * from "./RelationalGraph.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74dfe376",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/gkzy/Desktop/achievement-transform-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74dfe376')) {
      api.createRecord('74dfe376', component.options)
    } else {
      api.reload('74dfe376', component.options)
    }
    module.hot.accept("./RelationalGraph.vue?vue&type=template&id=74dfe376&scoped=true", function () {
      api.rerender('74dfe376', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/details/comps/RelationalGraph.vue"
export default component.exports